import { State } from "../../common/types/State";

export const initialState: State = {
    counter: 0,
};
